import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import AuthGuard from "../components/AuthGuard";
import { saveUserRole } from "../utils/firestoreUser";

const roleRoutes = {
  parent: "/app/profile",
  therapist: "/app/profile",
  shadow: "/app/profile",
  cdc: "/app/profile"
};

// Role selection page removed. No longer used.
export default function RoleSelection() { return null; }
